import { preview } from '@/components/form/preview'
import * as Texts from '../../intl'
import { Header } from './components/Header'
import { Props } from './typings'

export function SingleView(props: Props) {
  const { simulation } = props

  if (!simulation) {
    return null
  }
  const { name, label } = simulation

  return (
    <preview.Root applyPendingFitMapOnMount header={<Header simulation={simulation} />}>
      <preview.Field label={Texts.getSimulationNameFieldText()}>{name}</preview.Field>
      <preview.Field label={Texts.getSimulationLabelFieldText()}>
        {!label || label.trim() === '' ? '-' : label}
      </preview.Field>
    </preview.Root>
  )
}
